define('modules/form_editor/config',['require','exports','module','../editor/models/editorstate'],function(require, exports, module){
	"use strict";

	var EditorState = require("../editor/models/editorstate");

  module.exports = {
    googleRecaptcha: {
      urlBase: 'https://www.google.com/recaptcha/api.js',
      siteKey_v2: '6LfQem4UAAAAAFMlDn_tylSAZLVsnknKv4h6cEPm',
      siteKey_v3: '6LdvSwYaAAAAACWel113r-4pZUMnSNHwtVfMMVGG',
      defaultRenderMode: 'automatically',
      scriptTag: '',

      getSiteKey: function () {
        return EditorState.getAMPState() ?
            this.siteKey_v3 :
            this.siteKey_v2;
      }
    }
  };
});

